/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-personenbus-b3bceebb--sprite",
  "use": "car-personenbus-b3bceebb--sprite-usage",
  "viewBox": "0 0 47 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 47 24\" id=\"car-personenbus-b3bceebb--sprite\"><path d=\"M1 9v9a1 1 0 001 1h4M1 9h26.5M1 9V2a1 1 0 011-1h25.5M40 9h1a5 5 0 015 5v4a1 1 0 01-1 1h-5m0-10l-5.7-7.6a1 1 0 00-.8-.4h-6M40 9H27.5M40 19a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H14m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0M27.5 9V1\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M36.571 15L40 9H27.5v10H19L16 9V1M1 11h3v2H1.5M46 12h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
